import { use } from 'react';

import { MapActionsContext, type MapActionsContextValue } from './MapActionsContext';

/**
 * Frozen fallback used when no <MapActionsProvider> is present. MapView is also
 * rendered standalone on the savi route and in tests, with no provider: register
 * and flyToNetwork become no-ops so the bridge is simply inert.
 */
const NOOP_VALUE: MapActionsContextValue = Object.freeze({
    register: () => {},
    flyToNetwork: () => {},
});

/**
 * Reads the map-actions bridge used to dispatch imperative map behaviour (e.g. the
 * stats bar's Reset → fly to network) across the route/MapView tree boundary.
 * Returns a harmless no-op value when used outside a provider.
 */
export function useMapActions(): MapActionsContextValue {
    return use(MapActionsContext) ?? NOOP_VALUE;
}
